module.exports = {
  ...require('./data'),
};
